import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { supabase } from 'src/clientLib/supabase'
import { useTabNavigation } from 'src/redux/slices/navigation/hooks'
import { selectAuthorized } from 'src/redux/slices/user/selectors'

import { Button, Container, Grid } from '@material-ui/core'
import { Auth, ThemeSupa } from '@supabase/auth-ui-react'

//// Component
const LoginPage: React.FC = () => {
  const authorized = useSelector(selectAuthorized)
  const { goToTab } = useTabNavigation()
  useEffect(() => {
    if (authorized) {
      goToTab('user')
    }
  }, [authorized])
  return (
    <Container>
      <Auth
        supabaseClient={supabase}
        appearance={{
          theme: ThemeSupa,
          // variables: {
          //     default: {
          //         colors: {
          //             brand: "blue",
          //             brandAccent: "gray"
          //         }
          //     }
          // }
        }}
      />
    </Container>
  )
}

export default LoginPage
